import React from 'react'
import styled from 'styled-components'
import OurGoalsContent from './OurGoalsContent'

const OurGoals = () => {
    return (
        <Container>
            <div className="heading">
                <span>Our Goals</span>
                <h4>We Are Dedicated To Our Goals</h4>
            </div>
            <OurGoalsContent />
        </Container>
    )
}

export default OurGoals

const Container = styled.div`
    background: #fff;
    margin-bottom: -1rem;
    padding: 0rem 5rem;
    @media screen and (max-width: 900px){
        padding: 0rem;
    }
    .heading{
        text-align: center;
        padding: 0rem 10rem;
        padding-bottom: 2rem;
        span{
        font-weight: 600;
        display: block;
        margin-bottom: 10px;
        color: #e21f36;
        }
        h4{
            color: #000219;
            font-size: 2rem;
            font-weight: 800;
        }
        @media screen and (max-width: 900px){
            padding: 0rem 1rem;
            h4{
                font-size: 1rem;
            }
        }
    }
`